// triggerDownload.js
export function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoke a tick later so Firefox has time to start the download.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  return url;
}